import React from "react";

// packages
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// component
import Pill from "../../../common/Pill";

// styles
import styles from "./WaitingSellerJoin.module.scss";

const WaitingSellerJoin = () => {
  const { t } = useTranslation();
  return (
    <Pill
      styleName={styles["pending"]}
      Lefticon={
        <img src={"../../../assets/images/svg/waitingSettlement.svg"} />
      }>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_waiting_for_seller_to_join")}
      </p>
    </Pill>
  );
};

export default WaitingSellerJoin;
